import { useParams } from "react-router-dom";
import Footer from "../components/Footer";
import Header from "../components/Header";
import HamburgerMenu from "../components/HamburgerMenu";
import '../styles/DetailProjects.css';
import { projects } from '../data/projects';
import { useApp } from "../context/AppContext";

const DetailProject = () =>{
    const {menuActive, toggleMenu} = useApp();

    const { id } = useParams<{ id: string }>();

    const idProject = Number(id);

    const project = projects.find((p) => p.id === idProject);

    return (
        <div>
            <Header setOpenMenu={toggleMenu}></Header>
            <main className="project-detail">
                <section className="project-detail__left">
                    <h2>{project?.title}</h2>
                    <p>{project?.content}</p>
                    <picture className="project-image">
                        <img src={project?.image} alt="Imagen Proyecto" />
                    </picture>
                </section>
                <section className="project-detail__right">
                    {
                        (project?.url ? <a href={project?.url} className="btn-project" target="_blank">Visitar Proyecto</a> : "")
                    }
                    <nav>
                        <h3>Stack</h3>
                        <ul>
                            {
                                project?.tech.map((item, index) =>(
                                    <li>{item}</li>
                                ))
                            }
                        </ul>
                    </nav>
                </section>

            </main>
            <Footer/>
            <HamburgerMenu isOpenMenu={menuActive} setOpenMenu={toggleMenu}></HamburgerMenu>
        </div>
    )
}

export default DetailProject;